import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import cls from 'classnames';

import { IAvailableOption } from 'src/explore/types/shoppe';
import { ntc } from 'src/explore/services/currency_helper';

import { extractLastBracketKey } from '../../services';

import styles from './index.module.sass';

interface Props {
  defaultValue: IAvailableOption;
  disabled: boolean;
  label: string;
  name: string;
  options: IAvailableOption[];
  selectID: string;
  onChange: ( selection: string ) => void;
}

export const DropdownOption: React.FC<Props> = ({
  defaultValue,
  disabled,
  label,
  name,
  options,
  selectID,
  onChange,
}) => {
  const { register, setValue, watch } = useFormContext();
  const selectedOption = watch( name );
  const productVariantKey = extractLastBracketKey( name );

  useEffect(() => {
    const currentParams = new URLSearchParams( window.location.search );
    if ( currentParams.has( productVariantKey )) {
      const currentVariantOptionId = currentParams.get( productVariantKey );
      onChange( currentVariantOptionId );
      setValue( name, currentVariantOptionId );
    }

  }, [ name, productVariantKey, setValue ]);

  useEffect(() => {
    if ( selectedOption ) {
      const currentParams = new URLSearchParams( window.location.search );
      currentParams.set( productVariantKey, selectedOption );
      window.history.replaceState( null, '', `${window.location.pathname}?${currentParams.toString()}` );
    }
  }, [ selectedOption ]);

  const handleChange = ( event: React.ChangeEvent<HTMLSelectElement> ) => {
    onChange( event.target.value );
    setValue( name, event.target.value );
  };

  return (
    <div
      className={cls( 'form-group row pb-1 pb-md-0', {
        [styles.disabled]: disabled,
      })}
    >
      <div className="col">
        {label && (
          <label
            className={`${styles.label} p-0 mb-2 font-weight-normal fs-4 fs-md-5 product--product-option--label`}
            htmlFor={selectID}
          >
            {label}
          </label>
        )}

        <select
          {...register( name )}
          className={`${styles.select} form-control pl-4 rounded fs-5`}
          disabled={disabled}
          id={selectID}
          name={name}
          defaultValue={defaultValue && defaultValue.gbFormFieldValue}
          onChange={handleChange}
        >
          {options.map(( option ) => (
            <option
              key={option.gbFormFieldValue}
              disabled={!option.addToCart}
              value={option.gbFormFieldValue}
              data-price-adj={option.hasPriceAdj ? option.priceAdjInCents : undefined}
            >
              {option.gbFormFieldLabel + ( !option.addToCart ? ' (SOLD OUT)' : '' )}
              {option.hasPriceAdj &&
                ` (${option.priceAdjInCents > 0 ? '+' : ''}${ntc( option.priceAdjInCents, {
                  verbose: false,
                  precision: 2,
                })})`}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
